var _path, _mask, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5.25H8.38775H12.6123H17.5C18.4651 5.25 19.25 6.03488 19.25 7V16.625C19.25 17.5901 18.4651 18.375 17.5 18.375H3.5C2.53488 18.375 1.75 17.5901 1.75 16.625V7C1.75 6.03488 2.53488 5.25 3.5 5.25Z",
    fill: "#C4C4C4"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_2768_3098",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3814 2.0064L14.6186 3.24365L12.6875 5.25L8.38772 5.25003L6.38135 3.24365L7.6186 2.0064L10.5 4.88778L13.3814 2.0064Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6186 3.24365L16.0596 4.63059L17.4203 3.21689L16.0328 1.82944L14.6186 3.24365ZM13.3814 2.0064L14.7956 0.592187L13.3814 -0.822025L11.9671 0.592187L13.3814 2.0064ZM10.5 4.88778L9.08576 6.30199L10.5 7.7162L11.9142 6.30199L10.5 4.88778ZM7.6186 2.0064L9.03281 0.592187L7.6186 -0.822026L6.20438 0.592188L7.6186 2.0064ZM6.38135 3.24365L4.96713 1.82944L3.55292 3.24365L4.96713 4.65787L6.38135 3.24365ZM8.38772 5.25003L6.97351 6.66424L7.5593 7.25003L8.38774 7.25003L8.38772 5.25003ZM12.6875 5.25L12.6875 7.25L13.5384 7.25L14.1284 6.63694L12.6875 5.25ZM16.0328 1.82944L14.7956 0.592187L11.9671 3.42062L13.2044 4.65787L16.0328 1.82944ZM11.9671 0.592187L9.08576 3.47356L11.9142 6.30199L14.7956 3.42061L11.9671 0.592187ZM11.9142 3.47356L9.03281 0.592187L6.20438 3.42061L9.08576 6.30199L11.9142 3.47356ZM6.20438 0.592188L4.96713 1.82944L7.79556 4.65786L9.03281 3.42061L6.20438 0.592188ZM4.96713 4.65787L6.97351 6.66424L9.80194 3.83581L7.79556 1.82944L4.96713 4.65787ZM8.38774 7.25003L12.6875 7.25L12.6875 3.25L8.38771 3.25003L8.38774 7.25003ZM13.1776 1.85671L11.2465 3.86306L14.1284 6.63694L16.0596 4.63059L13.1776 1.85671Z",
    fill: "#5B5B5B",
    mask: "url(#path-2-inside-1_2768_3098)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 14V9.625L13.125 11.8125L8.75 14Z",
    fill: "#8E34F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.d5fb1e2f4f702b89f5579c3d3168e2dc.svg";
export { ForwardRef as ReactComponent };